// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"271d94fb","651":"0e8fa703","858":"f1a55052"}[chunkId] + ".chunk.js";
};